export default __webpack_public_path__ + "static/media/xpedition.49690a2a.png";